export default __webpack_public_path__ + "images/GL.1876cd3.png";